exports.connect = {
	url: "https://api.oreedubois.camp/"
}
